@if (productPlans || accountingPlan) {
	<panel width="700">
		@if (accountingPlan) {
			<menu always-visible>
				<menuitem *requiredCredential="credentialTypeEnum.EditLedgerPosts" (click)="editLedgerPosts()" [disabled]="accountingPlan.suspended != undefined">{{ 'ledger-posts.edit' | translate }}</menuitem>
				<menuitem *requiredCredential="credentialTypeEnum.EditLedgerPosts" (click)="editInvoiceInterval()" [disabled]="accountingPlan.suspended != undefined">{{ 'ledger-posts.edit-interval' | translate }}</menuitem>
				<menuitem (click)="compareLedgerPosts()" [disabled]="historicalTimestamps.length == 0">{{ 'ledger-posts.historical-changes' | translate }}</menuitem>
				<menuitem *requiredCredential="credentialTypeEnum.EditMigratedLedgerPosts" (click)="editMigratedLedgerPosts()" [disabled]="accountingPlan.suspended != undefined">{{ 'ledger-posts.edit-migrated-data' | translate }}</menuitem>
			</menu>
		}
		<h1>{{ 'ledger-posts.header' | translate }}</h1>
		<ledger-posts #ledgerPosts [productPlans]="productPlans" [accountingPlan]="accountingPlan" [displayProductName]="displayProductName" [splitByKey]="splitByKey" [editMode]="editMode" [allowChangingTotalValue]="true" [editMigratedData]="editMigratedData" [showClosedPosts]="showClosedPosts" />
		@if (editMode || editMigratedData) {
			<section>
				<button confirm #saveBillingPlan (click)="saveLedgerPosts()" [label]="'ledger.edit-ledger-posts.submit' | translate"></button>
				<button ghost (click)="resetEditMode()" [ignoreValidation]="true">{{ 'ledger.edit-ledger-posts.cancel' | translate }}</button>
			</section>
		}
	</panel>
}
